import { z } from "zod"

// Identity and role only. brian must never receive a Permut session token, or it could act as the
// employee. `isSuperadmin` gates destructive actions in brian's own UI.
export const VerifyBrianEmployeeResponseDataSchema = z.object({
  email: z.string(),
  name: z.string(),
  isSuperadmin: z.boolean(),
})
